export const imgExtensions = ['png', 'jpg', 'jpeg', 'gif', 'raw', 'cr2', 'nef', 'orf', 'sr2']

export const pdfExtensions = ['pdf']

export const audioExtensions = ['mp3', 'wav', 'ogg']

export function getFilename(filenameWithExtension: string) {
  return filenameWithExtension.split('.').slice(0, -1).join('.') ?? ''
}

export function getFileExtension(filenameWithExtension: string) {
  return filenameWithExtension.split('.').pop()?.toLowerCase() ?? 'unknown'
}
